export default "__VITE_ASSET__Ci5vuX$1__"